import { Component, EventEmitter, Inject, Input, OnChanges, Optional, Output, SimpleChanges } from '@angular/core';
import { GridModalComponent } from '@app/core/components/grid/grid.decorators';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';
import { ModalService } from '@app/core/services/modal.service';
import { StateDialogContext, TT_STATE_DIALOG } from '@app/modal/state-modal/state-modal.component';
import { ProductionRoutingService, ProductionRoutingCompParams, ProductionRoutingCompGet, ProductionRoutingWorkItem } from '@app/services/production-routing.service';
import { TypeaheadService } from '@app/services/typeahead.service';

@GridModalComponent('productionroutingcomp')
@Component({
    selector: 'tt-production-routing-comp',
    templateUrl: './production-routing-comp.component.html',
    styleUrls: ['./production-routing-comp.component.css'],
})
export class ProductionRoutingCompComponent implements OnChanges {
    @Input()
    public params?: ProductionRoutingCompParams;

    @Output()
    public submit = new EventEmitter<ProductionRoutingCompGet>();

    public get?: ProductionRoutingCompGet;

    public saving = false;

    public deleting = false;

    public quantitySources: QuantitySourceItem[] = [];

    public operations: ProductionRoutingWorkItem[] = [];

    constructor(private datatask: DataTaskService, private productionRouting: ProductionRoutingService, private typeahead: TypeaheadService, private modal: ModalService, @Inject(TT_STATE_DIALOG) @Optional() stateDialog?: StateDialogContext) {
        this.initFromDialog(stateDialog);
    }

    public searchProducts = () => {
        return this.typeahead.lookUpProducts({ prod_name: this.get!.prod_name });
    };

    public onProductSelected(event?: Item) {
        if (!this.get) return;

        this.get.prod_id = !!event ? '' + event.item_id : '';
        this.get.prod_name = event?.item_name ?? '';
    }

    public async save() {
        if (!this.get) return;

        this.saving = true;

        try {
            const { errorcode, errormessage } = await this.productionRouting.saveProductionRoutingComp(this.get);

            if ('' + errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
            } else {
                this.submit.emit(this.get);
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.saving = false;
        }
    }

    public async deleteComp() {
        if (!this.get) return;

        this.deleting = true;

        try {
            const { errorcode, errormessage } = await this.productionRouting.deleteProductionRoutingComp(this.get);

            if ('' + errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
            } else {
                this.submit.emit(this.get);
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.deleting = false;
        }
    }

    private async loadGet() {
        if (!!this.params) {
            this.get = await this.productionRouting.getProductionRoutingComp(this.params);
        }
    }

    private async loadQuantitySources() {
        this.quantitySources = await this.getQuantitySources();
    }

    private async loadOperations() {
        if (!!this.get) {
            this.operations = await this.productionRouting.getProductionRoutingWorks(this.get);
        }
    }

    private getQuantitySources(): Promise<QuantitySourceItem[]> {
        return this.datatask.Post(3887);
    }

    private async init() {
        this.loadQuantitySources();
        await this.loadGet();
        this.loadOperations();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['params']) {
            this.init();
        }
    }

    private async initFromDialog(stateDialog?: StateDialogContext) {
        if (!!stateDialog?.params) {
            this.params = stateDialog.params as unknown as ProductionRoutingCompParams;
            stateDialog.setSize({ width: 'min(70rem, 95vw)' });
            await this.init();
            this.submit.subscribe({ next: (value: ProductionRoutingCompGet) => stateDialog.close(value) });
            stateDialog.setHeading(this.get?.webpage_heading ?? '');
        }
    }
}

interface QuantitySourceItem {
    quantity_from: string;
    quantity_from_name: string;
    orderby: string;
}
